// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"02caf9e8516782e5ae1a","339":"08841ca758327a08d2cf"}[chunkId] + ".js";
};